{
  "bell_label": "Notifications",
  "panel_title": "Notifications",
  "mark_all_read": "Mark all as read",
  "empty": {
    "title": "No notifications",
    "description": "You will receive order updates and promotions here."
  },
  "types": {
    "order_confirmed": "Order confirmed",
    "order_shipped": "Order shipped",
    "order_delivered": "Order delivered",
    "payment_received": "Payment received",
    "payment_failed": "Payment failed",
    "return_approved": "Return approved",
    "return_rejected": "Return rejected",
    "promo": "Promotion",
    "loyalty_milestone": "Loyalty milestone",
    "stock_alert": "Stock alert",
    "welcome": "Welcome"
  },
  "channels": {
    "sms": "SMS",
    "whatsapp": "WhatsApp",
    "email": "Email",
    "push": "Push notifications",
    "in_app": "In-app"
  },
  "languages": {
    "fr": "French",
    "wo": "Wolof",
    "en": "English"
  },
  "preferences": {
    "channels_title": "Notification channels",
    "channels_description": "Choose how you want to receive your notifications.",
    "quiet_hours_title": "Quiet hours",
    "quiet_hours_description": "No push or SMS notifications will be sent during this period.",
    "quiet_start": "Start",
    "quiet_end": "End",
    "language_title": "Notification language",
    "save": "Save",
    "saving": "Saving..."
  },
  "timeAgo": {
    "now": "Just now",
    "minutes_one": "{{count}} minute ago",
    "minutes_other": "{{count}} minutes ago",
    "hours_one": "{{count}} hour ago",
    "hours_other": "{{count}} hours ago",
    "days_one": "{{count}} day ago",
    "days_other": "{{count}} days ago"
  }
}
